/**
 * Form interactions
 *
 * @since   1.0.0
 * @package veristream
 */
(function($) {
  // Hook for when elementor front end is loaded
  $(window).on('elementor/frontend/init', function() {
    //hook name is 'frontend/element_ready/{widget-name}.{skin}
    //$scope is a jquery wrapped parent element
    elementorFrontend.hooks.addAction('frontend/element_ready/step-slider.default', function($scope) {

      // mobile slider
      $('.step-slider-mobile').flickity({
        cellAlign: 'left',
        contain: true,
        pageDots: false,
      });


	  // desktop slider

      var stepSliderDesktop = $('.step-slider-desktop .image-slider').flickity({
        cellAlign: 'left',
        contain: true,
      });

      $('.steps-text').on('click', '.step-card', function() {
        var index = $(this).index();
        stepSliderDesktop.flickity('select', index);
        $('.step-card').each(function(e) {
          $(this).removeClass('active');
        });
        $(this).addClass('active');
      });

      stepSliderDesktop.on('change.flickity', function(event, index) {
		  $('.step-card').each(function(e) {
            $(this).removeClass('active');
          });
		  $('.step-card[data-index="' + index + '"]').addClass('active');
      });

	  // change default flickity buttons
	  if (window.innerWidth < 1100) {
		  $('.flickity-button.flickity-prev-next-button.next').html('<i class="fal fa-long-arrow-right"></i><div class="next-btn-text">next</div>');
	      $('.flickity-button.flickity-prev-next-button.previous').html('<i class="fal fa-long-arrow-left"></i><div class="prev-btn-text">prev</div>');
	  } else {
		  $('.flickity-button.flickity-prev-next-button.next').html('<div class="next-btn-text">next</div><i class="fal fa-long-arrow-right"></i>');
          $('.flickity-button.flickity-prev-next-button.previous').html('<i class="fal fa-long-arrow-left"></i><div class="prev-btn-text">prev</div>');
	  }




    });
  });

})(jQuery);
